import React, { useContext, useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Table as AntTable } from 'antd'
import { Wrapper } from './Table.styles'
import Modal from 'components/Modal/Modal'
import { selectors as gptPromptsSelectors, actions as gptPromptsActions } from 'domains/gptPrompts'
import { getColumns } from './config'
import { getRowKey } from 'helpers/tables'
import useAction from 'utils/useAction'

const Table = () => {
  const gptPrompts = useSelector(gptPromptsSelectors.gptPromptsSelector)
  const isLoaded = useSelector(gptPromptsSelectors.isLoadedSelector)
  const modal = useContext(Modal.Context)
  const fetchGptPrompts = useAction(gptPromptsActions.fetchGptPromptsRequest)

  useEffect(() => {
    if (!isLoaded) {
      fetchGptPrompts()
    }
  }, [isLoaded, fetchGptPrompts])

  const handleEdit = useCallback(
    (record) => {
      modal.open('gptPromptForm', { id: record.id })
    },
    [modal]
  )

  return (
    <Wrapper>
      <AntTable
        loading={!isLoaded}
        sticky
        pagination={{ position: ['bottomCenter'], showQuickJumper: true }}
        rowKey={getRowKey}
        dataSource={gptPrompts}
        columns={getColumns(handleEdit)}
        size="middle"
        bordered
      />
    </Wrapper>
  )
}

export default Table
